import React from "react";

const Me = () => {
  return <h3 style={{ padding: 24 }}>About Me page</h3>;
};

export default Me;
